import React, {useEffect, useState, useRef} from "react";
import GenStyles from "./styles/GenStyles.module.css";
import TTSStyles from "./styles/TTSStyles.module.css";
import {talk} from "./ALI_Ajax.js";
import {useUser} from "./UserContext";
import LoginModule from "./login_module";

const TextToSpeech = (props) => {
    const [prompt, setPrompt] = useState ('');
    const [pin, setPin] = useState('');
    const chatInputRef = useRef(null);
    const [filename, setFilename] = useState('');
    const [audioTag, setAudioTag] = useState(<></>);
    const {userId, finishedLoggingIn, is_user_in_role} = useUser();

    //USE EFFECTS
    useEffect(() => {
        generate_audio_tag();
    }, [filename]);
    useEffect(() => {
        console.log("AUDIO TAG: " + audioTag);
    }, [audioTag])

    //AJAX FUNCTIONS
    const generate_dalle_image = (word) => {
        console.log("Sending bulk tts prompt to server.");

        let postData = {
            operation: "GENERATE_DALLE_IMAGE",
            prompt: word,
            filename: word,
            pin: pin
        }

        talk("./ali_api/OpenAI_Handler.php", "GENERATE_DALLE_IMAGE", postData, bulk_text_to_speech_handler);
    }
    const generate_dalle_iamge_handler = (operation, sent_data, return_data) => {
        console.log(return_data);
    }
    const bulk_text_to_speech = () => {
        console.log("Sending bulk tts prompt to server.");

        let postData = {
            operation: "BULK_TEXT_TO_SPEECH",
            prompt: prompt,
            pin: pin
        }

        talk("./ali_api/OpenAI_Handler.php", "BULK_TEXT_TO_SPEECH", postData, bulk_text_to_speech_handler);
    }
    const bulk_text_to_speech_handler = (operation, sent_data, return_data) => {
        console.log(return_data);
    }
    const text_to_speech = () => {
        console.log("Sending prompt to server:", prompt);

        let postData = {
            operation: "GENERATE_SPEECH",
            prompt: prompt,
            pin: pin
        }

        talk("./ali_api/OpenAI_Handler.php", "CHAT", postData, text_to_speech_handler);
    }
    const text_to_speech_handler = (operation, sent_data, return_data) => {
        if(return_data['filename']) {
            setFilename(return_data['filename']);
        }
        setPrompt('');
        chatInputRef.current.focus();
    }


    //BASIC FUNCTIONS
    const handle_keydown_in_textarea = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            text_to_speech();
        }
    }
    const generate_audio_tag = () => {
        console.log("Generating new audio tag for file: " + filename);

        if(!filename) {
            return <></>
        }

        setAudioTag(
        <audio key={filename} controls autoPlay={true}>
            <source src={`../ali_api/${filename}`} type="audio/mpeg"/>
            Your browser does not support the audio tag.
        </audio>
        )
    }


    return (
        <>
            {
                finishedLoggingIn  && is_user_in_role('ADMIN') ?
                    <>
                    {/* Header */}
                    <div className={GenStyles.container} style={{marginTop: "80px"}} id="showcase">
                        <h1 className={GenStyles.jumbo}><b>ALI</b></h1>
                        <h1 className={`${GenStyles.xxxlarge} ${GenStyles.text_umkc_blue}`}><b>Text to Speech</b></h1>
                        <hr style={{width: "50px", border: "5px solid #ffd52f"}} className={GenStyles.round}/>
                    </div>


                {userId ?
                    <div className={TTSStyles.main}>
                        <div
                            className={TTSStyles.tts_output_box}
                            id="output_div"
                        >{audioTag}</div>
                        <div className={TTSStyles.tts_input_form}>
                            <textarea
                                id="userInput"
                                placeholder="Type your message here..."
                                className={TTSStyles.tts_input_text}
                                value={prompt}
                                onChange={event => setPrompt(event.target.value)}
                                ref={chatInputRef}
                                onKeyDown={handle_keydown_in_textarea}
                            ></textarea>
                            <input
                                type="text"
                                id="userPin"
                                placeholder="Enter your PIN"
                                className={TTSStyles.tts_input_text}
                                value={pin}
                                onChange={event => setPin(event.target.value)}
                            />
                            <button
                                className={TTSStyles.tts_button}
                                onClick={text_to_speech}
                            >
                                Generate Speech
                            </button>
                            <button
                                className={TTSStyles.tts_button}
                                onClick={bulk_text_to_speech}
                            >
                                Bulk Generate Speech
                            </button>
                            <button
                                className={TTSStyles.tts_button}
                                onClick={() => generate_dalle_image(prompt)}
                            >
                                Generate Image
                            </button>
                        </div>
                    </div>
                    : <LoginModule />}
                </> :
                <div>loading</div>
            }
        </>
    );
}

export default TextToSpeech;
